module.exports = "<th>Парковка</th>\n<td>\n  <terms\n    items=\"::terms.parking_type\"\n    source=\"source.parking_type\"\n    />\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/parking_type.html
// module id = 351
// module chunks = 0